export interface ResetPasswordFromToken {
	confirmNewPassword?: string;
	newPassword?: string;
	token?: string;
}

export class ResetPasswordFromToken implements ResetPasswordFromToken {
	constructor(data?: Partial<ResetPasswordFromToken>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}